export default __webpack_public_path__ + "static/media/ic-ppt1.31f10058.svg";